import React from 'react';

const Footer = () =>{
    return(
        <div className="footer__default">
    <div className="container">
        <div className="footer__inner default2">

        <small>Cell: +8801726369928 | Email: info@dreisspace.com</small>
            <div className="footer__socials_container">
                <div className="privacy-link">
                    <span className="footer__copyright">© 2020

                        Dreis Space Limited.

                    </span>
                    {/* <a class="footer__privacy" href="#">

                        Privacy Policy

                    </a> */}

                </div>
            </div>
        </div>
    </div>

</div>

    );
}

export default Footer;